var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('div',{staticClass:"headshot-img",style:('background-image:url(' + encodeURI(_vm.image) + ')'),on:{"click":function($event){_vm.$router.push('/participants/' + _vm.item.id)}}}),_vm._v(" "),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.name)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d1bdfa2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Headshot.vue
// module id = null
// module chunks = 